module.exports = __webpack_public_path__ + "media/components/country-flag/static/kg-3c724d5ab940a2f3480a0675dabd0dc0.svg";